import React from "reactn";
import { Dialog } from "primereact/dialog";
const ModalMostrarMensaje = (props) =>
    <Dialog header={props.titulo} visible={props.visible} style={{ width: '50vw' }} onHide={props.hide}>
        <p>{props.msj}</p>
    </Dialog>
export default ModalMostrarMensaje;